var _rect, _path, _path2, _path3, _path4, _g, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnterprisePlusLab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.711914,
    y: 8,
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_2936_206783)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4976 32.0479L13.2119 34.6649",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2119 24.6325V34.6644L22.4619 39.8984M13.2119 24.6325L22.4619 29.8665M13.2119 24.6325L22.4619 19.3984L31.7119 24.6325M22.4619 29.8665V39.8984M22.4619 29.8665L31.7119 24.6325M22.4619 39.8984L31.7119 34.6644V24.6325",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4614 25.9413L18.4971 27.686V32.0477L22.4614 34.2286M22.4614 25.9413L25.9852 27.686V32.0477L22.4614 34.2286M22.4614 25.9413V19.835M22.4614 34.2286V39.8988",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9854 32.0479L31.2711 34.6649",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2936_206783)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.7119,
    cy: 16,
    r: 10,
    fill: "url(#paint1_linear_2936_206783)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3015 20.7735C31.3879 20.9599 31.5747 21.0791 31.7801 21.0791L41.8941 21.0791C42.0995 21.0791 42.2863 20.9599 42.3728 20.7735C42.4592 20.5871 42.4297 20.3675 42.297 20.2107L38.3762 15.5743L38.3762 11.9765L38.6067 11.9765C38.8981 11.9765 39.1344 11.7403 39.1344 11.4488C39.1344 11.1574 38.8981 10.9212 38.6067 10.9212L37.8496 10.9212C37.8492 10.9212 37.8489 10.9212 37.8485 10.9212L35.8257 10.9212C35.8254 10.9212 35.825 10.9212 35.8247 10.9212L35.0681 10.9212C34.7766 10.9212 34.5404 11.1574 34.5404 11.4488C34.5404 11.7403 34.7766 11.9765 35.0681 11.9765L35.298 11.9765L35.298 15.5743L31.3772 20.2107C31.2446 20.3675 31.215 20.5871 31.3015 20.7735ZM36.3534 11.9765L37.3208 11.9765L37.3208 15.7675C37.3208 15.8923 37.365 16.013 37.4456 16.1082L40.7568 20.0237L32.9175 20.0237L36.2286 16.1082C36.3092 16.013 36.3534 15.8923 36.3534 15.7675L36.3534 11.9765Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2936_206783",
    x: 20.7119,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2936_206783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2936_206783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2936_206783",
    x1: 2.28109,
    y1: 24.5646,
    x2: 44.2892,
    y2: 29.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2936_206783",
    x1: 27.2171,
    y1: 12.5267,
    x2: 46.8941,
    y2: 13.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EF741D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE5A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE3B00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterprisePlusLab);
export default __webpack_public_path__ + "static/media/icon-enterprise-plus-lab.b6e336669f1e20bb7959dbbcd52f1056.svg";
export { ForwardRef as ReactComponent };